jQuery( document ).ready( function() {
	let inputValue; // Define the variable in an accessible scope
	let categoryValue;
	let paged;
	// Capture the form input value when the form is submitted
	jQuery( '#ajax-search-form' ).submit( function( e ) {
		e.preventDefault();
		inputValue = jQuery( '#ajax-search-value' ).val();
		if ( history.pushState ) {
			let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
			if ( inputValue !== '' || inputValue !== undefined ) {
				oldurl += '?s=' + inputValue;
			}
			window.history.pushState( { path: oldurl }, '', oldurl );
		}
		sendAjaxRequest();
	} );
	jQuery( '.ajax-testimonial-cate' ).click( function() {
		jQuery( '.ajax-testimonial-cate' ).removeClass( 'active-category' );
		 jQuery( this ).addClass( 'active-category' );
		categoryValue = jQuery( this ).data( 'category-slug' );
		sendAjaxRequest();
	} );
	jQuery( '.pagination span' ).on( 'click', function() {
		 jQuery( 'html' ).animate( {
			scrollTop: 0,
		}, 'slow' );
		paged = jQuery( this ).data( 'page' );
		sendAjaxRequest();
	} );
	jQuery( '#ajax-reset-button,.js-search-close' ).click( function( e ) {
		jQuery( '.category.button' ).removeClass( 'active-category' );
		inputValue = '';
		jQuery( '#ajax-search-value' ).val( inputValue );
		 categoryValue = '';
		 paged = 1;
		 	if ( history.pushState ) {
			let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
			if ( inputValue !== '' || inputValue !== undefined ) {
				oldurl += '?s=' + inputValue;
			}
			window.history.pushState( { path: oldurl }, '', oldurl );
		}

		sendAjaxRequest();
	} );
	function sendAjaxRequest() {
		jQuery( '.init-loader' ).show();
		jQuery( '#ajax-search-container' ).empty();
		jQuery( '#ajax-search-pagination-container' ).empty();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST', // Use 'GET' or 'POST' as needed
			data: {
				action: 'ajax_search_category_filter',
				inputValue,
				categoryValue,
				paged,

			 }, // Pass the data to the server
			success( response ) {
				// Handle the server's response here
				jQuery( '#ajax-search-container' ).html( response.html );

				jQuery( '#ajax-search-pagination-container' ).html( response.pagination );

				jQuery( '.pagination span' ).on( 'click', function() {
					3;
					jQuery( 'html' ).animate( {
						scrollTop: 0,
					}, 'slow' );
					paged = jQuery( this ).data( 'page' );
					sendAjaxRequest();
				} );
				paged = 1;
				jQuery( '.init-loader' ).hide();
			},
			error( xhr, status, error ) {
				jQuery( '.init-loader' ).hide();
				error_html = `<h2 class="heading-4 center-align">${ error }</h2>`;
				jQuery( '#ajax-search-container' ).html( error_html );
			},
		} );
	}
} );
